<div
  (click)="stopParentAction($event)"
  (contextmenu)="onRightClick($event)"
  (mousedown)="setMouseDown(true, $event)"
  (mouseup)="setMouseDown(false, $event)"
  [ngClass]="editorClass"
>
  <div
    *ngIf="!editable && !isMobileTable"
    class="editor"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
  >
    <div *ngIf="!isLink" class="word-break">{{
      currentText + textAppended
      }}<rav-icon
        *ngIf="shouldShowIcon"
        (click)="showEditor($event)"
        [name]="RavIcon.Pencil"
        class="editor__icon--large"
        data-cy="rename-icon"
      >
      </rav-icon>
    </div>
    <div *ngIf="isLink" class="table-editor word-break">
      <a [class.disabled]="disabled" [attr.data-cy]="'editor-current-text'" (click)="navigateToLink()">{{
        currentText + textAppended
      }}</a>
      <rav-icon
        *ngIf="shouldShowIcon"
        (click)="showEditor($event)"
        [name]="RavIcon.Pencil"
        class="editor__icon"
        data-cy="rename-icon"
      >
      </rav-icon>
    </div>
  </div>

  <form *ngIf="editable || isMobileTable" (click)="stopParentAction($event)">
    <div class="editor-input">
      <input
        class="editor-input-field"
        value="{{ currentText }}"
        type="text"
        (click)="stopParentAction($event)"
        (dblclick)="stopParentAction($event)"
        [(ngModel)]="currentText"
        [attr.data-cy]="!isMobileTable ? 'rename-input' : 'mobile-rename-input'"
        name="input"
      />
      <p *ngIf="textAppended" class="text-appended">{{ 
        textAppended 
      }}</p>
      <div class="input-group-button">
        <button
          class="button"
          [attr.data-cy]="!isMobileTable ? 'button-confirm' : 'mobile-button-confirm'"
          type="submit"
          (click)="editText($event)"
          [disabled]="!isValid"
        >
          <rav-icon class="input-group-button-icon success" [name]="RavIcon.Check"></rav-icon>
        </button>
        <button class="button" data-cy="button-cancel" (click)="cancel($event)">
          <rav-icon class="input-group-button-icon" [name]="RavIcon.EditorCancel"></rav-icon>
        </button>
      </div>
    </div>
  </form>
</div>
